import { type FC } from 'react';
import { useCreateNewMap } from '~/_shared/components/prepareDataModal/useCreateNewMap';
import { useStorageService } from '~/_shared/utils/storageService';
import { useModal } from '~/modal/useModal.hook';
import { useClientIsNew } from '~/store/userData/userData.selectors';
import { MapListSortType } from './mapListing.helpers';
import { MobileMapListingComponent } from './mobileMapListing.component';
import { useMapListingToggleManagement } from './useMapListingToggleManagement.hook';

const seenMobileUseDesktopRecommendation = 'seenMobileUseDesktopRecommendation';

export const MobileMapListingContainer: FC = () => {
  const {
    selectedMapIds, selectedSubMapIds, onToggleShowSubMaps, mapListingItems, pagination, onPageChange,
    isLoading: isMapListingDataLoading, errorMessage, toggledMapIds,
  } = useMapListingToggleManagement(MapListSortType.Updated_DESC);

  const { openModal: openShareSettingsModal } = useModal('ShareMap');
  const { openModal: openUseDesktopModal } = useModal('MobileUseDesktop');
  const { onCreateNewMap } = useCreateNewMap();
  const storageService = useStorageService();
  const isClientNew = useClientIsNew();

  const hasSeenUseDesktopModal = !!storageService.getLocalStorageItem(seenMobileUseDesktopRecommendation);

  const markUseDesktopModalAsSeen = () =>
    storageService.setLocalStorageItem(seenMobileUseDesktopRecommendation, new Date().toISOString());

  const onCreateMapButtonClick = () => isClientNew && !hasSeenUseDesktopModal
    ? openUseDesktopModal({ onContinueOnMobile: onCreateNewMap, onClose: markUseDesktopModalAsSeen })
    : onCreateNewMap();

  return (
    <MobileMapListingComponent
      errorMessage={errorMessage}
      isMapListingDataLoading={isMapListingDataLoading}
      processedItems={mapListingItems}
      selectedMapIds={selectedMapIds}
      selectedSnapshotIds={selectedSubMapIds}
      toggledMapIds={toggledMapIds}
      toggleSubMapVisibility={onToggleShowSubMaps}
      pagination={pagination}
      onPageChange={onPageChange}
      onMapShareSettingsClick={openShareSettingsModal}
      onCreateMapButtonClick={onCreateMapButtonClick}
    />
  );
};
